import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';

@Pipe({
  name: 'displayConditionalString'
})
export class DisplayConditionalStringPipe implements PipeTransform {
  transform(value: boolean, conditionalString: string): string {
    if (!value) {
      return '';
    }
    if (StringHelper.isEmpty(conditionalString)) {
      return 'Ja';
    }
    return conditionalString;
  }
}
